import CollectStripePaymentDialog from './CollectStripePaymentDialog'
export * from './CollectStripePaymentDialog'
export default CollectStripePaymentDialog
